module.exports = __webpack_public_path__ + "static/img/join.4d4fc8d8.svg";